"use client";

import React, { ReactNode, useContext } from "react";
import { X } from "lucide-react";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";

interface CenterModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

const CenterModal = ({
  isOpen,
  onClose,
  title,
  children,
}: CenterModalProps) => {
  const { theme } = useContext(CMSModal);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div
        className={twMerge(
          "rounded-xl shadow-xl w-full max-w-xl max-h-[75vh] overflow-hidden flex flex-col animate-fadeIn border transition-colors",
          theme === "dark"
            ? "bg-[#262727] border-gray-800"
            : "bg-white border-gray-200",
        )}
      >
        {/* Header */}
        <div
          className={twMerge(
            "flex justify-between items-center px-6 py-4 border-b transition-colors",
            theme === "dark"
              ? "bg-[#262727] border-gray-800"
              : "bg-white border-gray-100",
          )}
        >
          <h3
            className={twMerge(
              "text-lg font-semibold",
              theme === "dark" ? "text-gray-100" : "",
            )}
          >
            {title}
          </h3>
          <button
            onClick={onClose}
            className={twMerge(
              "transition-colors",
              theme === "dark"
                ? "text-gray-400 hover:text-gray-200"
                : "text-gray-500 hover:",
            )}
          >
            <X size={20} />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="overflow-y-auto px-6 py-4 space-y-4">{children}</div>
      </div>
    </div>
  );
};

export default CenterModal;
